import { NodeModel } from "../_model/NodeModel";
import { DecorationFermentationBatch } from "../FermentationBatch/decorationFermentationBatch";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class FermentationBatch extends NodeModel {
    constructor(location = { x: 0, y:0}) {
        super("FermentationBatch");

        this.type = new Types().FermentationBatch;

        this.x = location.x;
        this.y = location.y;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 260;
        this.width = 235;
        this.tx = 0;
        this.Xw = 0;
        this.operationSelected = '';
        this.srcImg = require("@/assets/Fluxogramas/FermentacaoBatelada.png");
        this.data = [new Properties({...this })];
        this.jokerCaption = []

        this.decorate = async function(callback) {
            this.decorator = new DecorationFermentationBatch();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new FermentationBatch()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.decorator = null
            cloned.readOnly = this.readOnly
            cloned.expressionVisible = this.expressionVisible
            cloned.jokerCaption = this.jokerCaption
            cloned.data = this.data.map(d => d.clone());

            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.jokerCaption = node.jokerCaption
            this.data = node.data.map(d => new Properties({...d }));
        }

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs;
            }
            this.jokerCaption = node.jokerCaption
        }

        // Para caso o nó tenha connections.
        // this.removeConnection = (connectionId) => {
        //   this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
        // }
    }
}

export { FermentationBatch };